import { cn } from '@/lib/utils'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'text-[20px]',
  md: 'text-2xl',
  lg: 'text-3xl',
}

export function Logo({ className, size = 'md' }: LogoProps) {
  return (
    <span className={cn('select-none font-hand font-normal leading-none tracking-normal', sizeClasses[size], className)}>
      <span className="text-foreground">corppy</span>
      <span className="text-primary">.</span>
    </span>
  )
}
